import type {
  LicenseUpgradeSubmission,
  LicenseUpgradeSubmissionAccount,
} from '@/types'
import {
  LicenseType,
  LicenseUpgradeAccountStatus,
  LicenseUpgradeSubmissionStatus,
} from '@/types'

export interface GetLicenseUpgradeListParams {
  page?: number
  limit?: number
  status?: string
  kelas?: string
  search?: string
}

// TODO(KLRP-419): placeholder data + in-memory filtering — replace both list
// and detail functions with real axios calls (GET /operator-sekolah/
// upgrade-license, see docs/autosync-v3-tahap2-effort-operator-sekolah.md)
// once the BE API contract is agreed
const PLACEHOLDER_SUBMISSIONS: LicenseUpgradeSubmission[] = [
  {
    id: 1,
    created_at: '2026-06-24T15:00:00',
    npsn: '1000129388',
    total_accounts: 50,
    reason:
      'Alasan Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore',
    status: LicenseUpgradeSubmissionStatus.BelumDisetujui,
    submitted_by: 'Operator Sekolah Placeholder 1',
    document_name: 'surat-pengajuan-upgrade-1.pdf',
    document_url: '#',
  },
  {
    id: 2,
    created_at: '2026-06-20T10:30:00',
    npsn: '1000129388',
    total_accounts: 25,
    reason: 'Kebutuhan pembelajaran berbasis platform untuk seluruh kelas 12.',
    status: LicenseUpgradeSubmissionStatus.Disetujui,
    submitted_by: 'Operator Sekolah Placeholder 2',
    document_name: 'surat-pengajuan-upgrade-2.pdf',
    document_url: '#',
  },
  {
    id: 3,
    created_at: '2026-06-15T09:00:00',
    npsn: '1000129388',
    total_accounts: 10,
    reason: 'Pengajuan ulang untuk akun yang belum terupgrade.',
    status: LicenseUpgradeSubmissionStatus.Ditolak,
    submitted_by: 'Operator Sekolah Placeholder 3',
    document_name: 'surat-pengajuan-upgrade-3.pdf',
    document_url: '#',
  },
]

export const getLicenseUpgradeSubmissions = async (
  params: GetLicenseUpgradeListParams,
) => {
  const statuses = params.status ? params.status.split(',') : []
  const keyword = (params.search || '').toLowerCase().trim()

  const data = PLACEHOLDER_SUBMISSIONS.filter((item) => {
    const matchStatus = !statuses.length || statuses.includes(String(item.status))
    const matchSearch = !keyword || String(item.npsn).includes(keyword)

    return matchStatus && matchSearch
  })

  return {
    data: {
      data,
      meta: {
        page: params.page || 1,
        total: data.length,
      },
    },
  }
}

export const getLicenseUpgradeSubmission = async (id: string | number) => {
  const data = PLACEHOLDER_SUBMISSIONS.find(
    item => String(item.id) === String(id),
  )

  return {
    data: {
      data: data || null,
    },
  }
}

const PLACEHOLDER_LICENSES = [
  LicenseType.Fundamental,
  LicenseType.GmailOnly,
  LicenseType.SsoOnly,
]

// 50 rows to exercise the accounts-per-submission pagination
const PLACEHOLDER_SUBMISSION_ACCOUNTS: LicenseUpgradeSubmissionAccount[]
  = Array.from({ length: 50 }, (_, i) => ({
    pd_id: `pd-placeholder-${i + 1}`,
    full_name: `Peserta Didik Placeholder ${i + 1}`,
    email: `placeholder${i + 1}@belajar.id`,
    kelas: `KELAS ${(i % 12) + 1}`,
    current_license_type: PLACEHOLDER_LICENSES[i % PLACEHOLDER_LICENSES.length],
    upgrade_status: LicenseUpgradeAccountStatus.Pending,
    new_license_type: null,
    upgraded_at: null,
    failure_reason: null,
  }))

// mirrors the proposed paginated sub-resource
// GET /operator-sekolah/upgrade-license/{id}/accounts?page=&limit=
export const getLicenseUpgradeSubmissionAccounts = async (
  id: string | number,
  params: { page?: number; limit?: number } = {},
) => {
  const page = params.page || 1
  const limit = params.limit || 20
  const start = (page - 1) * limit

  // execution only happens after approval: pengajuan #2 (DISETUJUI) demoes
  // executed outcomes incl. individual failures; the rest stay PENDING
  const executed = String(id) === '2'
  const rows = PLACEHOLDER_SUBMISSION_ACCOUNTS.map((account, i) => {
    if (!executed)
      return account

    if (i % 10 === 3) {
      return {
        ...account,
        upgrade_status: LicenseUpgradeAccountStatus.Failed,
        failure_reason: 'Akun tidak aktif (placeholder)',
      }
    }

    return {
      ...account,
      upgrade_status: LicenseUpgradeAccountStatus.Upgraded,
      new_license_type: LicenseType.Fundamental,
      upgraded_at: '2026-07-10T08:00:00',
    }
  })

  return {
    data: {
      data: rows.slice(start, start + limit),
      meta: {
        page,
        total: rows.length,
      },
    },
  }
}
